module.exports = __webpack_public_path__ + "media/make4.7f728d1f.mp4";